import { Application } from "@hotwired/stimulus"

import FlashController from "./flash_controller.js"
import HelloController from "./hello_controller.js"
import ProfileEditorController from "./profile_editor_controller.js"
import NotificationsDropdownController from "./notifications_dropdown_controller.js"
import FriendNetworkGraphController from "./friend_network_graph_controller.js"
import AdminFriendGraphUserPickerController from "./admin_friend_graph_user_picker_controller.js"
import AdminUserSelectionController from "./admin_user_selection_controller.js"
import ThemeController from "./theme_controller.js"
import MobileNavController from "./mobile_nav_controller.js"
import ActivityDatetimePickerController from "./activity_datetime_picker_controller.js"
import ActivityFormController from "./activity_form_controller.js"
import ActivityChatController from "./activity_chat_controller.js"

const application = Application.start()

application.register("flash", FlashController)
application.register("hello", HelloController)
application.register("profile-editor", ProfileEditorController)
application.register("notifications-dropdown", NotificationsDropdownController)
application.register("friend-network-graph", FriendNetworkGraphController)
application.register("admin-friend-graph-user-picker", AdminFriendGraphUserPickerController)
application.register("admin-user-selection", AdminUserSelectionController)
application.register("theme", ThemeController)
application.register("mobile-nav", MobileNavController)
application.register("activity-datetime-picker", ActivityDatetimePickerController)
application.register("activity-form", ActivityFormController)
application.register("activity-chat", ActivityChatController)

export { application }
